import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import Button from "@mui/material/Button";


interface MyAlertDialogProps {
    agreeText?: string;
    disagreeText?: string;
    questionText: string;
    contentText?: string;
    handleClose: () => void;
    handleAgree: () => void;
    agreeLoading?: boolean;
    open: boolean;
}


const MyAlertDialog = (props: MyAlertDialogProps) => {
    return (
        <>
            <Dialog
                open={props.open}
                onClose={props.handleClose}
            >
                <DialogTitle sx={{ display: "flex", alignItems: "center" }}>
                    <WarningRoundedIcon /> {props.questionText}
                </DialogTitle>
                {
                    props.contentText !== undefined &&
                    <DialogContent>
                        <DialogContentText>
                            {props.contentText}
                        </DialogContentText>
                    </DialogContent>
                }
                <DialogActions sx={{display: "flex", justifyContent: "space-around"}}>
                    <Button onClick={props.handleClose} color="inherit" variant="contained">
                        {props.disagreeText}
                    </Button>
                    <Button
                        onClick={() => {
                            props.handleAgree();
                            props.handleClose();
                        }}
                        loading={props.agreeLoading}
                        color="error"
                        variant="contained"
                    >
                        {props.agreeText}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default MyAlertDialog;
